import _ from 'underscore';
import { websiteImageSourceConfig } from './website-images-view';
import { stockImageSourceConfig } from './stock-images-view';
import { socialImageSourceConfig } from './social-images-view';
import { aigcImageSourceConfig } from './ai-generate-images-view';
import { getLandingPageConfig } from './landing-view';
import { investImageSourceConfig } from './invest-images-view';

import { VIEWS } from './view-type';

export { VIEWS };

export const getAddImageConfig = ({
  isAssetLibraryAIGCMVPEnabled,
  isLiteLandingPageEnabled,
  hideStockImage,
  isAdStudioEnabled,
  showPromotionBanner,
  panelTitle,
  panelSubtitle,
  isXandrIntegrationEnabled,
}) => {
  let config = {
    [VIEWS.WebsiteImage]: websiteImageSourceConfig,
    [VIEWS.StockImage]: stockImageSourceConfig,
    [VIEWS.SocialMedia]: socialImageSourceConfig,
    [VIEWS.LandingPage]: getLandingPageConfig(isAssetLibraryAIGCMVPEnabled, isLiteLandingPageEnabled, isAdStudioEnabled, showPromotionBanner, panelTitle, panelSubtitle),
  };
  if (isAssetLibraryAIGCMVPEnabled) {
    config = {
      [VIEWS.AIGCImage]: aigcImageSourceConfig,
      ...config,
    };
  }
  if (hideStockImage) {
    config = _.omit(config, VIEWS.StockImage);
  }

  if (isXandrIntegrationEnabled) {
    config = {
      ...config,
      [VIEWS.InvestImage]: investImageSourceConfig,
    };
  }

  return config;
};

